import { getConfig } from "@jti/fe-common";
import { getIsEvo, getUser } from "../../../utils";
import { UserCustomAttrsApiEvo } from "./UserCustomAttrsApiEvo/UserCustomAttrsApiEvo.v5";
import { CasCustomAttrsApiLegacy } from "./CasCustomAttrsApiLegacy";
export class CasCustomAttrsApi {
    static init() {
        const config = getConfig();
        const user = getUser();
        if (getIsEvo(config.CAS_URL)) {
            return new UserCustomAttrsApiEvo({
                baseUrl: config.CAS_URL,
                recaptchaId: config["X-RECAPTCHA-ID"],
                tenantToken: config.CAS_X_DES_AK_TENANT_TOKEN,
                ciamToken: user.ciam_token,
                userUuid: user.uuid || "",
            });
        }
        return new CasCustomAttrsApiLegacy(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token, user.uuid || "");
    }
}
//# sourceMappingURL=CasCustomAttrsApi.js.map